export enum OnboardingPhase {
  Welcome = 'welcome',
  Caller = 'caller',
  Feedback = 'feedback',
  Ready = 'ready',
}
